var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReversed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 800 800",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fill: "currentColor",
    stroke: "none",
    d: "M 800 400 C 800 179.080017 620.919983 0 400 0 C 179.080017 0 0 179.080017 0 400 C 0 620.919983 179.080017 800 400 800 C 620.919983 800 800 620.919983 800 400 Z M 200.493835 534.134033 L 200.493835 507.466797 L 433.893829 507.466797 C 486.613861 507.466797 529.519653 464.560944 529.519653 411.840942 C 529.519653 359.107513 486.613861 316.215088 433.893829 316.215088 L 414.721283 316.215088 L 414.721283 316.121246 L 251.587067 315.334686 L 328.373352 392.134338 L 309.520355 410.987366 L 200.480408 301.947449 L 307.65448 194.773376 L 326.507477 213.626343 L 251.453003 288.680817 L 428.186768 289.521027 L 428.186768 289.547821 L 433.880432 289.547821 C 501.319519 289.547821 556.173523 344.415253 556.173523 411.840942 C 556.173523 479.280029 501.319519 534.134033 433.880432 534.134033 C 433.880432 534.134033 200.493835 534.134033 200.493835 534.134033 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReversed);
export default __webpack_public_path__ + "static/media/reversed.bea906c896e17cc17efcfea28b9326f5.svg";
export { ForwardRef as ReactComponent };